import authType from '@/config/authType';

const formItems = [
  { label: '应用名称', model: 'appName', type: 'input', span: 6 },
  {
    type: 'select',
    label: '状态',
    model: 'appStatus',
    options: [
      { name: '全部', value: -1 },
      { name: '启用', value: 1 },
      { name: '禁用', value: 0 }
    ],
    fun: 'searchTableInfo',
    span: 6
  },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ],
    span: 12
  }
];
const getColumnsMap = (methods) => {
  return {
    appSortNum: {
      title: '顺序',
      key: 'appSortNum',
      width: 50,
      ellipsis: true,
      tooltip: true,
      align: 'right'
    },
    id: {
      title: '应用ID',
      key: 'id',
      minWidth: 300,
      ellipsis: true,
      tooltip: true
    },
    appName: {
      title: '应用名称',
      key: 'appName',
      width: 100,
      ellipsis: true,
      tooltip: true
    },
    orgName: {
      title: '通讯录名称',
      key: 'orgName',
      width: 100,
      ellipsis: true,
      tooltip: true
    },
    remark: {
      title: '应用描述',
      key: 'remark',
      minWidth: 300,
      ellipsis: true,
      tooltip: true
    },
    appUrl: {
      title: '应用地址',
      key: 'appUrl',
      minWidth: 300,
      ellipsis: true,
      tooltip: true
    },
    loginTimeoutSec: {
      title: '超时时长',
      key: 'loginTimeoutSec',
      width: 100,
      ellipsis: true,
      tooltip: true,
      align: 'right',
      render: (h, params) => {
        const { loginTimeoutSec } = params.row;
        return h('p', `${loginTimeoutSec}秒`);
      }
    },
    appStatus: {
      title: '状态',
      key: 'appStatus',
      width: 100,
      ellipsis: true,
      tooltip: true,
      align: 'center',
      render: (h, params) => {
        const { appStatus } = params.row;
        return h('Tag', appStatus == 0 ? { props: { 'color': 'volcano' } } : { props: { 'color': 'green' } }, appStatus == 0 ? '禁用' : '启用');
      }
    },
    operate: {
      title: '操作',
      key: 'operate',
      minWidth: 160,
      ellipsis: true,
      tooltip: true,
      fixed: 'right',
      render: (h, params) => {
        const buttonArr = [];
        if (params.row.appName != '权限系统') {
          buttonArr.push(h('CustomButton', {
            props: { type: 'error', size: 'small', permissionCode: authType.app.deleteRowAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.deleteAppBtnClick(params.row);
              }
            }
          }, '删除'));
        }
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small', permissionCode: authType.app.editRowAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                methods.editAppBtnClick(params.row);
              }
            }
          }, '编辑')
        );
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};

export { formItems, getColumns };
